import { render, staticRenderFns } from "./UserSettingsHelp.vue?vue&type=template&id=c6935376&scoped=true&"
import script from "./UserSettingsHelp.vue?vue&type=script&lang=js&"
export * from "./UserSettingsHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6935376",
  null
  
)

export default component.exports